export default __webpack_public_path__ + "static/media/About Pic.506cbfd7.jpg";